import { Type } from '@angular/core';
import { GraphUserServiceContract } from './services/graph-user-service.contract';

/**
 * Registers the host-supplied directory implementation for the user-management UI.
 *
 * @param directoryService a concrete class implementing {@link GraphUserServiceContract}.
 *   Its instance is resolved for `GraphUserServiceContract` wherever the library injects it.
 */
export function provideUserManagement(directoryService: Type<GraphUserServiceContract>) {
    return [directoryService, { provide: GraphUserServiceContract, useExisting: directoryService }];
}
